module.exports = __webpack_public_path__ + "static/media/3.aa386495.png";